/**
 * Drops trailing zeros from a rating so 4.70 renders as "4.7"
 */
export const formatRating = (rating: number | string | null | undefined) => {
	if (rating === null || rating === undefined || rating === '') return ''

	const parsed = typeof rating === 'number' ? rating : Number(String(rating).replace(',', '.'))
	if (!Number.isFinite(parsed)) return String(rating)

	return String(Number(parsed.toFixed(2)))
}
